import { ProviderShell } from "@/components/provider/ProviderShell";
import { ProgressNotesPanel } from "@/components/provider/ProgressNotesPanel";

export default function ProviderProgressNotesPage() {
  return (
    <ProviderShell title="Progress notes" eyebrow="PAID AT 30 MINUTES PER APPROVED NOTE" back="/provider-portal/work" testId="provider-progress-notes-page">
      <ProgressNotesPanel />
    </ProviderShell>
  );
}
